<template>
  <div class="m-edition-map-chart-points">
    <AtomSelectPrimary
       v-model="selected"
       :elements="options"
       key-field="id"
       name="equipos"
       reference="equipos"
       text-field="nombre"
       @change="selectedOption"
    />

    <div
      v-if="showEmpty"
      class="font-size-small margin-top-xxlarge text-align-center"
    >
      <p v-if="selected === '0'">
        {{ $t('mEditionMapChartPoints.messageAlertTeam.firstText') }}
        <a
          class="text-link-hover-maps"
          href="#"
          @click.prevent="goTo"
        >
          {{ $t('mEditionMapChartPoints.messageAlertTeam.secondText') }}
        </a>
      </p>

      <p v-if="selected === '1'">
        <span>{{ $t('mEditionMapChartPoints.messageAlertNoTeam.firstText') }}</span>
      </p>

      <p v-if="selected !== '0' && selected !=='1'">
        {{ $t('mEditionMapChartPoints.messageAlertFamily.firstText') }}
        "{{ selectedData.nombre }}",
        <a
          class="text-link-hover-maps"
          href="#" @click.prevent="goTo"
        >
          {{ $t('mEditionMapChartPoints.messageAlertFamily.secondText') }}
        </a>
      </p>
    </div>

    <div v-else>
      <ol v-if="showLoadingState === false">
        <li
          v-for="integrante in familia"
          :key="integrante.id ? integrante.id : integrante.alumno"
        >
          <span class="item-data">
            <img
              class="a-avatar-primary"
              :src="integrante.avatar ? integrante.avatar : (integrante.logo ? integrante.logo : avatar)"
            />
            <span class="ellipsis width-150-px">
              {{ integrante.razon_social ? integrante.razon_social : integrante.nombre }}
            </span>
          </span>
          <span class="item-points">
            {{ integrante.puntos }}
            <i class="fas fa-star text-color-notifications-primary"></i>
          </span>
        </li>
      </ol>
      <ol v-else>
        <li
          v-for="index in 1"
          :key="index"
        >
          <span class="item-data">
            <img src="@/assets/img/avatar.png">
            <span class="ellipsis width-150-px">
              {{ $t('mEditionMapChartPoints.messageLoading.firstText') }}
            </span>
          </span>
          <span class="item-points">
            0
            <i class="fas fa-star text-color-notifications-primary"></i>
          </span>
        </li>
      </ol>
    </div>

    <MoleculePaginationSecondary
      :pagination="pagination"
      @setPaginationCurrentPage="setPaginationCurrentPage"
    />
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapChartPoints',

  components: {
    MoleculePaginationSecondary: () => import('@/components/molecules/MoleculePaginationSecondary')
  },

  data () {
    return {
      avatar: require('@/assets/img/avatar.png'),
      familia: [],

      filter: {
        estado: '',
        fecha_creacion: '',
        integrante: '',
        limite: 10,
        nombre_familia: '',
        pagina: 1
      },

      options: [],

      pagination: {
        currentPage: 1,
        limit: 10,
        showLoadingState: false,
        totalPages: 1
      },

      selected: '',
      selectedData: [],
      showEmpty: false,
      showLoadingState: true
    }
  },

  watch: {
    familia () {
      this.$emit('setProgress', this.familia)
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.proyectoId = this.$route.params.id
    this.readFamiliaNombres()
  },

  methods: {
    goTo () {
      if (this.selected === '0') {
        this.$router.push(`/${this.$t('rPaths.map')}/${this.proyectoId}/${this.$t('mEditionMenu.map.enrollments.subject')}/${this.$t('mEditionMenu.map.enrollments.children.families.subedition')}`)
      } else {
        this.$router.push(`/${this.$t('rPaths.map')}/${this.proyectoId}/${this.$t('mEditionMenu.map.enrollments.subject')}/${this.selectedData.id}/${this.$t('mEditionMenu.map.enrollments.children.familyMembers.subedition')}`)
      }
    },

    readAlumnosSinEquipos () {
      this.showEmpty = false
      if (!this.pagination.showLoadingState) {
        // this.pagination.showLoadingState = true
        this.$services.read('familia', 'readInscripcionesSinFamilia', {}, [this.proyectoId], this.filter)
          .then(response => {
            this.familia = []
            this.familia = response.data.inscripciones
            this.pagination.totalPages = response.data.pages
            this.pagination.showLoadingState = false
            this.showLoadingState = false
            if (this.familia.length > 0) {
              this.showEmpty = false
            } else {
              this.showEmpty = true
            }
          })
          .catch(error => {
            console.log(error)
            this.pagination.totalPages = 0
            this.pagination.showLoadingState = false
            this.showLoadingState = false
            this.showEmpty = true
          })
      }
    },

    readFamiliaEquipos () {
      this.showEmpty = false
      if (!this.pagination.showLoadingState) {
        // this.pagination.showLoadingState = true
        this.$services.read('familia', 'readFamilias', {}, [this.proyectoId], this.filter)
          .then(response => {
            this.familia = []
            this.familia = response.data.familias
            this.pagination.totalPages = response.data.pages
            this.pagination.showLoadingState = false
            this.showLoadingState = false
            if (this.familia.length > 0) {
              this.showEmpty = false
            } else {
              this.showEmpty = true
            }
          })
          .catch(error => {
            console.log(error)
            this.pagination.totalPages = 0
            this.pagination.showLoadingState = false
            this.showLoadingState = false
            this.showEmpty = true
          })
      }
    },

    readFamiliaMiembros () {
      this.showEmpty = false
      if (!this.pagination.showLoadingState) {
        this.$services.read('familia', 'readFamiliaMiembros', {}, [this.selected], this.filter)
          .then(response => {
            this.familia = []
            this.familia = response.data.integrantes
            this.pagination.totalPages = response.data.pages
            this.pagination.showLoadingState = false
            this.showLoadingState = false
            if (this.familia.length > 0) {
              this.showEmpty = false
            } else {
              this.showEmpty = true
            }
          })
          .catch(error => {
            console.log(error)
            this.pagination.totalPages = 0
            this.pagination.showLoadingState = false
            this.showLoadingState = false
            this.showEmpty = true
          })
      }
    },

    readFamiliaNombres () {
      this.$services.read('familia', 'readFamiliaNombres', {}, [this.proyectoId])
        .then(response => {
          this.options = response.data
          this.options.unshift({ id: '0', nombre: 'Todos los equipos' }, { id: '1', nombre: 'Alumnos sin equipo' })
          this.selected = '0'
          this.readFamiliaEquipos()
        })
        .catch(error => {
          console.log(error)
        })
    },

    selectedOption () {
      if (this.selected !== '') {
        this.showLoadingState = true
        this.selectedData = this.options.find(element => element.id === this.selected)
        if (this.selected === '0') {
          this.readFamiliaEquipos()
        } else {
          if (this.selected === '1') {
            this.readAlumnosSinEquipos()
          } else {
            this.readFamiliaMiembros()
          }
        }
      }
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.selectedOption()
    }

  }
}
</script>
